import { GroupBase, MultiValueProps } from 'chakra-react-select';

const MultiValue = <
Option = unknown,
IsMulti extends boolean = boolean,
Group extends GroupBase<Option> = GroupBase<Option>,
>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _props: MultiValueProps<Option, IsMulti, Group>
) => null;

export default MultiValue;